module.exports = "/matchcenter-staging/assets/images/sport24_webtv.d03cdf25bee936d0f47cf69a33dc7094.png";